import { forwardRef, type SelectHTMLAttributes } from 'react';

/**
 * Select conforme alla regola di progetto: freccia disegnata (SVG a
 * right 12px center) e padding-right ampio, così il testo non finisce
 * mai sotto la freccia e la freccia non tocca il bordo.
 */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...props }, ref) {
    return (
      <select
        ref={ref}
        className={`select-panda min-h-11 rounded-lg border border-ink-300 bg-white px-3 py-2 text-ink-900 dark:border-ink-600 dark:bg-ink-900 dark:text-ink-50 ${className ?? ''}`}
        {...props}
      >
        {children}
      </select>
    );
  },
);
